import { RouterModule } from "@angular/router";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { DocumentSignComponent } from "./views/default/document-sign.component";
import { DocumentSignService } from "./service/document-sign.service";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { FormsModule } from "@angular/forms";
import { CheckboxModule } from "primeng/checkbox";
import { RadioButtonModule } from "primeng/radiobutton";
import { InputTextModule } from "primeng/inputtext";
import { MessagesModule } from "primeng/messages";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { PaginatorModule } from "primeng/paginator";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { SidebarModule } from "primeng/sidebar";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { DividerModule } from "primeng/divider";

@NgModule({
  declarations: [DocumentSignComponent],
  providers: [DocumentSignService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    ButtonModule,
    ConfirmDialogModule,
    DialogModule,
    CheckboxModule,
    RadioButtonModule,
    InputTextModule,
    ConfirmDialogModule,
    MessagesModule,
    NgxExtendedPdfViewerModule,
    PaginatorModule,
    BrowserAnimationsModule,
    ProgressSpinnerModule,
    SidebarModule,
    ScrollPanelModule,
    DividerModule,
    TranslateModule,
    RouterModule.forChild([{ path: "", component: DocumentSignComponent }]),
  ],
})
export class DocumentSignModule {}
